/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useEffect, useState } from "react";

type Props = {
  url: string;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const SvgInline = ({ url, ...rest }: Props) => {
  const [svg, setSvg] = useState<string | null>(null);

  useEffect(() => {
    fetch(url)
      .then((res) => res.text())
      .then(setSvg);
  }, [url]);

  if (!svg) {
    return null;
  }

  return <div {...rest} dangerouslySetInnerHTML={{ __html: svg }} />;
};
